import { ItemList } from '../orm'

class BpointPayment extends ItemList {
    getEntityKey() {
        return "customer/purchased_trolley/verify_bpoint_payment"
    }

    verifyPayment({ payment_ref, has_timed_out }) {
      return this.saveNewObject({
        payment: payment_ref,
        has_timed_out: has_timed_out,
      })
    }
    
}

export const bpointPayment = new BpointPayment("bpoint_payment_default")


